module.exports = __webpack_public_path__ + "media/images/home/close-243800141486054ebe917862587c9881.svg";